export const pageNames = {
	contacts: 'Contacts',
	gra: 'Group Risk Assessment',
	myActiveProjects: 'My Active Projects',
	dashboard: 'Dashboard',
	createProject: 'Create Project',
	createGra: 'Create GRA',
	userSettings: 'User Settings'
};

export const siteSections = {
	contacts: 'Contacts',
	gra: 'Group Risk Assessment',
	home: 'Home',
	project: 'Project',
	projects: 'Projects',
	userAccount: 'User Account'
};
